export const DetectedIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4.5 12.0078H7L9.5 4.50781L14.5 19.5078L17 12.0078H19.5" stroke="white" stroke-opacity="0.5"
          stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);